module.exports = __webpack_public_path__ + "static/media/DWFuturaLatinExtB.b46a3d40.woff";